import { useEffect, useRef } from 'react';
import { brandValues } from '@/mocks/products';

function AboutSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.about-animate').forEach((el) => {
              el.classList.add('animate-in');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="sobre"
      ref={sectionRef}
      className="py-12 md:py-20 bg-background-100"
    >
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-4xl mx-auto text-center">
        <div className="about-animate opacity-0 translate-y-6 transition-all duration-700 mb-10">
          <span className="inline-block text-xs font-medium text-primary-700 tracking-wider uppercase mb-2">
            Sobre a Maçã Verde
          </span>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
            A Maçã Verde veste a infância com peças confortáveis, bonitas e pensadas para o dia a dia das crianças.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 md:gap-8 items-stretch">
          {brandValues.map((value, index) => (
            <div
              key={value.id}
              className="about-animate opacity-0 translate-y-6 transition-all duration-700 h-full"
              style={{ transitionDelay: `${150 + index * 100}ms` }}
            >
              <div className="bg-background-50 rounded-xl p-6 h-full">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 mx-auto mb-3">
                  <i className={`${value.icon} text-xl`} />
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">
                  {value.title}
                </h3>
                <p className="text-sm text-foreground-600">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .about-animate.animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}

export default AboutSection;